function inlineFilterItems() {
  return [
    {
      id: 'all',
      label: 'Semua',
    },
    {
      id: 'ACTIVE',
      label: 'Aktif',
    },
    {
      id: 'INACTIVE',
      label: 'Tidak Aktif',
    },
    {
      id: 'FAILED',
      label: 'Gagal Dijalankan',
    },
  ]
}

export default inlineFilterItems
